(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
/**
 * AnnouncementCountdown — bar ticker Web Component.
 * Reads data-end (ISO datetime string, interpreted as PT) and counts down.
 * Auto-hides the entire announcement section when the deadline passes.
 */
class AnnouncementCountdown extends HTMLElement {
  #interval = null;
  #endMs = 0;

  connectedCallback() {
    const rawEnd = this.dataset.end;
    if (!rawEnd) return;

    // Parse the datetime string as Pacific Time.
    // The Shopify date_time picker gives "YYYY-MM-DDTHH:MM" (no timezone).
    // We append the PT offset so the browser treats it correctly.
    this.#endMs = this.#parsePacificTime(rawEnd);
    if (!this.#endMs) return;

    this.#tick();
    this.#interval = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#interval);
  }

  /**
   * Parse a "YYYY-MM-DDTHH:MM" string as America/Los_Angeles.
   * Uses Intl to work out whether PT is currently PST (-08:00) or PDT (-07:00).
   * @param {string} raw
   * @returns {number} milliseconds since epoch
   */
  #parsePacificTime(raw) {
    try {
      // Append a UTC offset that matches the current PT offset.
      const offset = this.#getPacificOffset(raw);
      return new Date(`${raw}:00${offset}`).getTime();
    } catch {
      return 0;
    }
  }

  /**
   * Determine the UTC offset for America/Los_Angeles at a given naive datetime string.
   * @param {string} naiveDatetime "YYYY-MM-DDTHH:MM"
   * @returns {string} e.g. "-08:00" or "-07:00"
   */
  #getPacificOffset(naiveDatetime) {
    // Probe using UTC midnight to avoid chicken-and-egg, then refine.
    const probe = new Date(`${naiveDatetime}:00Z`);
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'shortOffset'
    });
    const parts = formatter.formatToParts(probe);
    const tz = parts.find(p => p.type === 'timeZoneName')?.value ?? 'GMT-8';
    // tz is like "GMT-7" or "GMT-8"
    const match = tz.match(/GMT([+-]\d+)/);
    if (!match) return '-08:00';
    const hrs = parseInt(match[1], 10);
    const pad = String(Math.abs(hrs)).padStart(2, '0');
    return `${hrs < 0 ? '-' : '+'}${pad}:00`;
  }

  #tick() {
    const now = Date.now();
    const remaining = this.#endMs - now;

    if (remaining <= 0) {
      this.#expire();
      return;
    }

    const { days, hours, minutes, seconds } = this.#breakdown(remaining);

    // Render as "01d : 09h : 10m : 16s" in the single ticker span
    const ticker = this.querySelector('[data-countdown-ticker]');
    if (ticker) {
      const d = String(days).padStart(2, '0');
      const h = String(hours).padStart(2, '0');
      const m = String(minutes).padStart(2, '0');
      const s = String(seconds).padStart(2, '0');
      ticker.textContent = `${d}d : ${h}h : ${m}m : ${s}s`;
    }

    // Also sync any matching panel countdown (same section)
    this.#syncPanel({ days, hours, minutes, seconds });
  }

  #syncPanel({ days, hours, minutes, seconds }) {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;
    const section = document.getElementById(`announcement-${sectionId}`);
    if (!section) return;

    // Sync panel countdown digits
    const panel = section.querySelector('[data-countdown-panel]');
    if (panel) {
      const set = (attr, val) => {
        const el = panel.querySelector(`[${attr}]`);
        if (el) el.textContent = val;
      };
      set('data-panel-countdown-days', String(days).padStart(2, '0'));
      set('data-panel-countdown-hours', String(hours).padStart(2, '0'));
      set('data-panel-countdown-minutes', String(minutes).padStart(2, '0'));
      set('data-panel-countdown-seconds', String(seconds).padStart(2, '0'));
    }

  }

  #breakdown(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  }

  #expire() {
    clearInterval(this.#interval);
    // Hide the entire announcement section gracefully
    const sectionId = this.dataset.sectionId;
    if (sectionId) {
      const section = document.getElementById(`announcement-${sectionId}`);
      if (section) {
        section.style.transition = 'opacity 0.4s ease, max-height 0.4s ease';
        section.style.overflow = 'hidden';
        section.style.opacity = '0';
        section.style.maxHeight = '0';
        setTimeout(() => section.remove(), 500);
      }
    }
  }
}

customElements.define('announcement-countdown', AnnouncementCountdown);

/**
 * Panel countdown — handles the expanded drawer's countdown panels.
 * Standalone panels (not inside the bar Web Component) fall back to this.
 */
(function initPanelCountdowns() {
  function getPacificOffset(naiveDatetime) {
    const probe = new Date(`${naiveDatetime}:00Z`);
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'shortOffset'
    });
    const parts = formatter.formatToParts(probe);
    const tz = parts.find(p => p.type === 'timeZoneName')?.value ?? 'GMT-8';
    const match = tz.match(/GMT([+-]\d+)/);
    if (!match) return '-08:00';
    const hrs = parseInt(match[1], 10);
    const pad = String(Math.abs(hrs)).padStart(2, '0');
    return `${hrs < 0 ? '-' : '+'}${pad}:00`;
  }

  function parsePT(raw) {
    try {
      return new Date(`${raw}:00${getPacificOffset(raw)}`).getTime();
    } catch {
      return 0;
    }
  }

  function breakdown(ms) {
    const total = Math.floor(ms / 1000);
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60
    };
  }

  // Panels that aren't already driven by the bar Web Component
  const panels = document.querySelectorAll('[data-countdown-panel]');
  for (const panel of panels) {
    const raw = panel.dataset.end;
    if (!raw) continue;
    const endMs = parsePT(raw);
    if (!endMs) continue;

    // Skip if already synced by the bar component
    const barComponent = panel.closest('section')?.querySelector('announcement-countdown');
    if (barComponent) continue;

    const tick = () => {
      const remaining = endMs - Date.now();
      if (remaining <= 0) {
        panel.style.display = 'none';
        clearInterval(id);
        return;
      }
      const { days, hours, minutes, seconds } = breakdown(remaining);
      const set = (attr, val) => {
        const el = panel.querySelector(`[${attr}]`);
        if (el) el.textContent = String(val).padStart(2, '0');
      };
      set('data-panel-countdown-days', days);
      set('data-panel-countdown-hours', hours);
      set('data-panel-countdown-minutes', minutes);
      set('data-panel-countdown-seconds', seconds);
    };

    tick();
    const id = setInterval(tick, 1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalog-quick-order"] && !Shopify.designMode) return;
  try {
    
  /* Catalog Quick Order
     -------------------
     A custom element, so section reload and removal in the theme editor are
     handled by connectedCallback and disconnectedCallback rather than by
     listening for shopify:section:* on the document. */

  class CatalogQuickOrder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const cfgEl = this.querySelector('[data-qo-config]');
      this.cfg = JSON.parse(cfgEl.textContent);
      this.t = this.cfg.strings;
      this.root = (this.cfg.rootUrl || '/').replace(/\/$/, '');
      this.storageKey = 'qo:list:' + this.cfg.collection;
      this.indexKey = 'qo:index:v2:' + this.cfg.collection + ':' + this.cfg.currency + ':' + this.cfg.locale;

      this.list = [];
      this.index = [];
      this.bySku = Object.create(null);
      this.taItems = [];
      this.taIdx = -1;
      this.lastRemoved = null;
      this.lastFocus = null;
      this.activeInfo = null;
      this.descCache = Object.create(null);
      this.abort = new AbortController();

      this.el = {
        input: this.querySelector('[data-qo-input]'),
        addBtn: this.querySelector('[data-qo-add]'),
        ta: this.querySelector('[data-qo-ta]'),
        rows: this.querySelector('[data-qo-rows]'),
        empty: this.querySelector('[data-qo-empty]'),
        count: this.querySelector('[data-qo-count]'),
        clear: this.querySelector('[data-qo-clear]'),
        dock: this.querySelector('[data-qo-dock]'),
        right: this.querySelector('.qo__right'),
        dockCount: this.querySelector('[data-qo-dock-count]'),
        dockTotal: this.querySelector('[data-qo-dock-total]'),
        ship: this.querySelector('[data-qo-ship]'),
        shipText: this.querySelector('[data-qo-ship-text]'),
        shipFill: this.querySelector('[data-qo-ship-fill]'),
        toast: this.querySelector('[data-qo-toast]'),
        toastText: this.querySelector('[data-qo-toast-text]'),
        toastAction: this.querySelector('[data-qo-toast-action]'),
        live: this.querySelector('[data-qo-live]'),
        tabs: this.querySelector('[data-qo-tabs]'),
        catGrid: this.querySelector('[data-qo-catgrid]'),
        link: this.querySelector('[data-qo-link]'),
        cartBtn: this.querySelector('[data-qo-cart]'),
        miniTotal: this.querySelector('[data-qo-mini-total]'),
        miniCount: this.querySelector('[data-qo-mini-count]'),
        miniPrice: this.querySelector('[data-qo-mini-price]')
      };

      this.money = new Intl.NumberFormat(this.cfg.locale || 'en-US', {
        style: 'currency',
        currency: this.cfg.currency || 'USD'
      });

      this.bind();
      this.loadList();
      this.render();
      this.buildIndex();

      if (this.fromLink && this.list.length) {
        this.toast(this.t.restored + ' · ' + this.count() + ' ' + this.t.itemsUnit);
      }
    }

    disconnectedCallback() {
      this.ready = false;
      this.abort.abort();
      clearTimeout(this.toastTimer);
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onPanelScroll) window.removeEventListener('scroll', this.onPanelScroll);
      document.body.style.overflow = '';
    }

    /* ---------------------------------------------------------- utilities */

    esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]
      ));
    }

    norm(s) {
      return String(s || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
    }

    fmt(tpl, vars) {
      let out = String(tpl || '');
      Object.keys(vars || {}).forEach((k) => {
        out = out.replace('[[' + k + ']]', vars[k]);
      });
      return out;
    }

    img(url, w) {
      if (!url) return '';
      const clean = String(url).split('&width=')[0];
      return clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    /* -------------------------------------------------------------- index
       Prefetched once and cached. Matching is then local, which matters
       when someone is standing in a garden on one bar of signal. */

    async buildIndex() {
      const cached = this.readIndexCache();
      if (cached) {
        this.setIndex(cached);
        return;
      }
      try {
        const items = [];
        for (let page = 1; page <= 8; page += 1) {
          const url = this.root + '/collections/' + encodeURIComponent(this.cfg.collection) +
                      '/products.json?limit=250&page=' + page;
          const res = await fetch(url, { signal: this.abort.signal });
          if (!res.ok) throw new Error('index request failed');
          const data = await res.json();
          const products = (data && data.products) || [];
          products.forEach((p) => this.flatten(p, items));
          if (products.length < 250) break;
        }
        if (!items.length) throw new Error('empty index');
        this.setIndex(items);
        this.writeIndexCache(items);
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.indexFailed = true;
        if (this.el.input.value.trim()) this.renderTA();
      }
    }

    flatten(p, out) {
      const tags = (p.tags || []).map((x) => String(x));
      const lower = tags.map((x) => x.toLowerCase());
      let cat = '';
      let sub = '';
      tags.forEach((tag) => {
        if (/^cat\s*-\s*/i.test(tag)) cat = tag.replace(/^cat\s*-\s*/i, '').trim();
        if (/^subcat\s*-\s*/i.test(tag)) sub = tag.replace(/^subcat\s*-\s*/i, '').trim();
      });
      const heirloom = lower.some((x) => x.indexOf('heirloom') > -1);
      const fallbackImg = (p.images && p.images[0] && p.images[0].src) || '';

      (p.variants || []).forEach((v) => {
        if (!v.sku) return;
        const vt = v.title && v.title !== 'Default Title' ? v.title : '';
        out.push({
          sku: String(v.sku).trim(),
          id: v.id,
          h: p.handle,
          t: p.title,
          vt: vt,
          p: Math.round(parseFloat(v.price) * 100) || 0,
          a: v.available !== false,
          img: (v.featured_image && v.featured_image.src) || fallbackImg,
          c: sub || cat || p.product_type || '',
          sec: cat || p.product_type || '',
          o: lower.indexOf('organic') > -1 || /organic/i.test(vt),
          hl: heirloom
        });
      });
    }

    setIndex(items) {
      this.index = items;
      this.searchRecords = items.map((it) => ({ it, name: this.norm(it.t), sku: this.norm(it.sku), full: this.norm(it.t + ' ' + it.c + ' ' + it.vt + ' ' + it.sku) }));
      this.bySku = Object.create(null);
      items.forEach((it) => { this.bySku[it.sku] = it; });
      this.renderTabs();
      this.render();
      if (this.el.input.value.trim()) this.renderTA();
    }

    readIndexCache() {
      try {
        const raw = localStorage.getItem(this.indexKey);
        if (!raw) return null;
        const blob = JSON.parse(raw);
        const maxAge = (this.cfg.cacheHours || 12) * 3600 * 1000;
        if (!blob || !blob.ts || Date.now() - blob.ts > maxAge) return null;
        return blob.items || null;
      } catch (e) {
        return null;
      }
    }

    writeIndexCache(items) {
      try {
        localStorage.setItem(this.indexKey, JSON.stringify({ ts: Date.now(), items: items }));
      } catch (e) {
        /* quota or private mode; the page works without the cache */
      }
    }

    /* -------------------------------------------------------------- search
       Item number wins outright. Name and category matches rank so a hit at
       the start beats one mid-string. */

    search(term) {
      const raw = term.trim();
      if (!raw) return [];
      const digits = raw.replace(/[^0-9]/g, '');
      const scored = [];

      if (digits.length >= 2 && /^#?\d+$/.test(raw.replace(/\s/g, ''))) {
        this.index.forEach((it) => {
          if (it.sku === digits) scored.push({ it: it, s: 1000 });
          else if (it.sku.indexOf(digits) === 0) scored.push({ it: it, s: 900 - it.sku.length });
        });
        if (scored.length) return this.rank(scored);
      }

      const n = this.norm(raw);
      if (!n) return [];
      (this.searchRecords || []).forEach(({ it, name, sku, full }) => {
        let s = 0;
        if (sku === n) s = 1000;
        else if (sku.indexOf(n) === 0) s = 900;
        else if (name === n) s = 800;
        else if (name.indexOf(n) === 0) s = 700;
        else if ((' ' + full).indexOf(' ' + n) > -1) s = 600;
        else if (full.indexOf(n) > -1) s = 400;
        if (s) scored.push({ it: it, s: s - it.t.length * 0.3 - (it.a ? 0 : 200) });
      });
      return this.rank(scored);
    }

    rank(a) {
      a.sort((x, y) => y.s - x.s);
      return a.slice(0, 25).map((o) => o.it);
    }

    hl(text, term) {
      const n = this.norm(term);
      if (!n) return this.esc(text);
      const i = this.norm(text).indexOf(n);
      if (i < 0) return this.esc(text);
      return this.esc(text.slice(0, i)) + '<mark>' + this.esc(text.slice(i, i + n.length)) +
             '</mark>' + this.esc(text.slice(i + n.length));
    }

    renderTA() {
      const term = this.el.input.value;
      this.taItems = this.search(term);
      this.taIdx = this.taItems.length ? 0 : -1;

      if (!term.trim()) { this.closeTA(); this.el.addBtn.disabled = true; return; }
      this.el.addBtn.disabled = !this.taItems.length;

      if (!this.taItems.length) {
        this.el.input.removeAttribute('aria-activedescendant');
        const msg = this.indexFailed ? this.t.indexError : this.t.noMatchHelp;
        this.el.ta.innerHTML = '<div class="qo__tanone"><b>' +
          this.fmt(this.t.noMatch, { term: this.esc(term) }) + '</b>' + this.esc(msg) + '</div>';
        this.openTA();
        return;
      }

      const isNum = /^#?\d+$/.test(term.trim());
      const showImg = this.cfg.showImages;
      const html = this.taItems.map((it, i) => {
        const meta = [it.c, it.vt, it.a ? '' : this.t.soldOut]
          .filter(Boolean).join(' · ');
        return '<button type="button" class="qo__tarow" role="option" data-i="' + i + '"' +
          ' id="qo-option-' + this.cfg.sectionId + '-' + i + '" tabindex="-1" aria-selected="' + (i === this.taIdx) + '"' +
          ' data-unavailable="' + (it.a ? '0' : '1') + '">' +
          (showImg && it.img
            ? '<img class="qo__tathumb" src="' + this.esc(this.img(it.img, 80)) + '" alt="" loading="lazy" width="38" height="48">'
            : '<span class="qo__tasku">' + (isNum ? this.hl(it.sku, term.replace(/[^0-9]/g, '')) : '#' + this.esc(it.sku)) + '</span>') +
          '<span class="qo__tatxt">' +
            '<span class="qo__taname">' + (isNum ? this.esc(it.t) : this.hl(it.t, term)) + '</span>' +
            '<span class="qo__tameta">#' + this.esc(it.sku) + (meta ? ' · ' + this.esc(meta) : '') + '</span>' +
          '</span>' +
          '<span class="qo__taprice">' + this.money.format(it.p / 100) + '</span>' +
        '</button>';
      }).join('');

      this.el.input.setAttribute('aria-activedescendant', 'qo-option-' + this.cfg.sectionId + '-' + this.taIdx);
      this.el.ta.innerHTML = html +
        '<div class="qo__tafoot"><span>' + this.esc(this.t.enterToAdd) + '</span>' +
        '<span>' + this.esc(this.t.arrowsToChoose) + '</span></div>';
      this.openTA();
    }

    openTA() { this.el.ta.setAttribute('data-open', '1'); this.el.input.setAttribute('aria-expanded', 'true'); }
    closeTA() { this.el.input.removeAttribute('aria-activedescendant'); this.el.ta.setAttribute('data-open', '0'); this.el.input.setAttribute('aria-expanded', 'false'); }

    moveTA(d) {
      if (!this.taItems.length) return;
      this.taIdx = (this.taIdx + d + this.taItems.length) % this.taItems.length;
      this.el.input.setAttribute('aria-activedescendant', 'qo-option-' + this.cfg.sectionId + '-' + this.taIdx);
      this.el.ta.querySelectorAll('.qo__tarow').forEach((r, i) => {
        r.setAttribute('aria-selected', String(i === this.taIdx));
        if (i === this.taIdx) r.scrollIntoView({ block: 'nearest' });
      });
    }

    /* ------------------------------------------------------ list mutations
       Adding is optimistic. An Undo in the toast is cheaper for the reader
       than a confirm step paid on every one of twenty adds. */

    add(sku, qty, quiet) {
      const it = this.bySku[sku];
      if (!it) return false;
      const n = qty || 1;
      const existing = this.list.find((x) => x.sku === sku);
      if (existing) existing.qty = Math.min(99, existing.qty + n);
      else this.list.unshift({ sku: sku, qty: n });
      if (!quiet) this.render(sku);
      if (!quiet) {
        const label = it.t + (it.vt ? ' (' + it.vt + ')' : '');
        this.toast(this.fmt(existing ? this.t.updated : this.t.added, { name: label }));
        this.say(label + '. ' + this.count() + ' ' + this.t.itemsUnit + ', ' + this.money.format(this.total() / 100) + '.');
        this.emit('add', { sku: sku, quantity: n, variantId: it.id });
      }
      return true;
    }

    remove(sku) {
      const i = this.list.findIndex((x) => x.sku === sku);
      if (i < 0) return;
      this.lastRemoved = { item: this.list[i], at: i };
      this.list.splice(i, 1);
      this.render();
      const it = this.bySku[sku];
      this.toast(this.fmt(this.t.removed, { name: it ? it.t : '#' + sku }), () => {
        this.list.splice(this.lastRemoved.at, 0, this.lastRemoved.item);
        this.lastRemoved = null;
        this.render();
      });
      this.emit('remove', { sku: sku });
    }

    setQty(sku, q) {
      const it = this.list.find((x) => x.sku === sku);
      if (!it) return;
      const n = Math.max(0, Math.min(99, q));
      if (n === 0) { this.remove(sku); return; }
      it.qty = n;
      this.render();
    }

    count() { return this.list.reduce((a, i) => a + i.qty, 0); }

    total() {
      return this.list.reduce((a, i) => {
        const it = this.bySku[i.sku];
        return a + (it ? it.p * i.qty : 0);
      }, 0);
    }

    /* -------------------------------------------------------------- render */

    render(flashSku) {
      const focused = document.activeElement;
      const focusedRow = focused && focused.closest('.qo__row');
      const focusedSku = focusedRow && focusedRow.getAttribute('data-sku');
      const focusedAction = focusedRow && focused.getAttribute('data-act');
      const known = this.list.filter((i) => this.bySku[i.sku]);
      const showImg = this.cfg.showImages;

      this.el.rows.innerHTML = known.map((row) => {
        const it = this.bySku[row.sku];
        const chips =
          (it.o ? '<span class="qo__chip qo__chip--org">' + this.esc(this.t.organic) + '</span>' : '') +
          (it.hl ? '<span class="qo__chip qo__chip--heir">' + this.esc(this.t.heirloom) + '</span>' : '') +
          (it.a ? '' : '<span class="qo__chip qo__chip--out">' + this.esc(this.t.soldOut) + '</span>');
        const media = showImg && it.img
          ? '<img class="qo__thumb" src="' + this.esc(this.img(it.img, 130)) + '" alt="" loading="lazy" width="56" height="72">'
          : '<span class="qo__packet" aria-hidden="true"><span class="qo__packettop"></span>' +
            '<span class="qo__packetno">#' + this.esc(it.sku) + '</span>' +
            '<span class="qo__packetseal"></span></span>';

        return '<li class="qo__row' + (row.sku === flashSku ? ' qo__row--new' : '') + '" data-sku="' + this.esc(it.sku) + '">' +
          media +
          '<span class="qo__rowmain">' +
            '<span class="qo__rowcat">' + this.esc(it.c) + '</span>' +
            '<span class="qo__rowname">' + this.esc(it.t) + '</span>' +
            '<span class="qo__rowmeta">' + chips +
              (it.vt ? '<span>' + this.esc(it.vt) + '</span>' : '') +
              '<span>#' + this.esc(it.sku) + '</span>' +
            '</span>' +
            '<span class="qo__rowctl">' +
              '<span class="qo__stepper">' +
                '<button type="button" data-act="dec" aria-label="' + this.esc(this.fmt(this.t.decrease, { name: it.t })) + '">&minus;</button>' +
                '<input type="number" min="0" max="99" value="' + row.qty + '" data-act="qty" aria-label="' + this.esc(this.fmt(this.t.quantity, { name: it.t })) + '">' +
                '<button type="button" data-act="inc" aria-label="' + this.esc(this.fmt(this.t.increase, { name: it.t })) + '">+</button>' +
              '</span>' +
              '<button type="button" class="qo__icon" data-act="info" aria-label="' + this.esc(this.fmt(this.t.details, { name: it.t })) + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg></button>' +
              '<button type="button" class="qo__remove" data-act="del" aria-label="' + this.esc(this.fmt(this.t.remove, { name: it.t })) + '">' +
                '<img src="' + this.esc(this.cfg.trashIconUrl) + '" width="16" height="16" alt="" aria-hidden="true"></button>' +
            '</span>' +
          '</span>' +
          '<span class="qo__rowprice"><b>' + this.money.format(it.p * row.qty / 100) + '</b>' +
            (row.qty > 1 ? '<span>' + this.money.format(it.p / 100) + ' ' + this.esc(this.t.each) + '</span>' : '') +
          '</span>' +
        '</li>';
      }).join('');

      const n = this.count();
      const t = this.total();
      const has = known.length > 0;

      this.el.miniTotal.hidden = !has;
      this.el.miniCount.textContent = String(n);
      this.el.miniPrice.textContent = this.money.format(t / 100);
      this.el.empty.hidden = has;
      this.el.count.textContent = String(n);
      this.el.clear.hidden = !has;
      this.el.dockCount.textContent = String(n);
      this.el.dockTotal.textContent = this.money.format(t / 100);
      this.el.dock.setAttribute('data-show', has ? '1' : '0');

      if (this.el.ship) {
        const gap = this.cfg.freeShipping - t;
        if (!has || !this.cfg.showFreeShipping) {
          this.el.ship.hidden = true;
        } else {
          this.el.ship.hidden = false;
          if (gap > 0) {
            this.el.shipText.innerHTML = this.fmt(this.esc(this.t.freeShippingGap), {
              amount: '<b>' + this.money.format(gap / 100) + '</b>'
            });
            this.el.shipFill.style.width = Math.min(100, (t / this.cfg.freeShipping) * 100) + '%';
          } else {
            this.el.shipText.innerHTML = '<b>' + this.esc(this.t.freeShippingMet) + '</b>';
            this.el.shipFill.style.width = '100%';
          }
        }
      }

      if (focusedSku && focusedAction) {
        const row = Array.from(this.el.rows.children).find((item) => item.getAttribute('data-sku') === focusedSku);
        const control = row && row.querySelector('[data-act="' + focusedAction + '"]');
        (control || this.el.input).focus({ preventScroll: true });
      }
      this.syncDock();
      this.saveList();
      this.writeHash();
    }

    syncDock() {
      if (window.innerWidth >= 900) { this.style.setProperty('--qo-dock-h', '0px'); return; }
      this.style.setProperty('--qo-dock-h', (this.list.length ? this.el.dock.offsetHeight : 0) + 'px');
    }

    /* --------------------------------------------------------- persistence
       Silent local autosave stops accidental loss. The URL hash is the
       portable copy a reader can send themselves. */

    saveList() {
      try { localStorage.setItem(this.storageKey, JSON.stringify(this.list)); } catch (e) { /* noop */ }
    }

    loadList() {
      const m = location.hash.match(/^#l=(.+)$/);
      if (m) {
        const parsed = this.decode(m[1]);
        if (parsed.length) { this.list = parsed; this.fromLink = true; return; }
      }
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (raw) {
          const saved = JSON.parse(raw);
          this.list = Array.isArray(saved) ? saved.filter((row) => row && typeof row.sku === 'string' && Number.isInteger(row.qty) && row.qty > 0 && row.qty <= 99) : [];
        }
      } catch (e) { this.list = []; }
    }

    encode() {
      if (this.list.every((i) => /^\d{3,}$/.test(i.sku))) {
        return this.list.map((i) => (i.qty > 1 ? i.sku + '.' + i.qty : i.sku)).join('-');
      }
      return 'v2:' + this.list.map((i) => encodeURIComponent(i.sku) + (i.qty > 1 ? ':' + i.qty : '')).join(',');
    }

    decode(s) {
      if (s.startsWith('v2:')) {
        try {
          return s.slice(3).split(',').map((tok) => {
            const parts = tok.split(':');
            if (parts.length > 2 || (parts[1] !== undefined && !/^[1-9]\d?$/.test(parts[1]))) {
              throw new Error('Invalid saved quantity');
            }
            const sku = decodeURIComponent(parts[0]);
            if (!sku.trim()) throw new Error('Empty saved SKU');
            return { sku: sku, qty: Number(parts[1] || 1) };
          });
        } catch (e) {
          return [];
        }
      }
      return s.split('-').map((tok) => {
        const parts = tok.split('.');
        return { sku: parts[0], qty: Math.max(1, Math.min(99, parseInt(parts[1] || '1', 10) || 1)) };
      }).filter((i) => /^\d{3,}$/.test(i.sku));
    }

    savedListUrl() {
      const url = new URL(location.pathname, location.origin);
      if (this.cfg.themeRole && this.cfg.themeRole !== 'main' && this.cfg.themeId) {
        url.searchParams.set('preview_theme_id', String(this.cfg.themeId));
      }
      url.hash = 'l=' + this.encode();
      return url.href;
    }

    writeHash() {
      const h = this.list.length ? '#l=' + this.encode() : '';
      if (h !== location.hash) {
        history.replaceState(null, '', location.pathname + location.search + h);
      }
    }

    /* ---------------------------------------------------------------- cart */

    async addAllToCart() {
      if (this.el.cartBtn.disabled) return;
      const known = this.list.filter((i) => this.bySku[i.sku]);
      if (!known.length) return;

      const btn = this.el.cartBtn;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      const line = (row) => ({
        id: this.bySku[row.sku].id,
        quantity: row.qty,
        properties: { 'Catalog item': '#' + row.sku }
      });

      try {
        const res = await fetch(this.cfg.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: known.map(line) })
        });
        if (!res.ok) {
          const error = await res.json().catch(() => ({}));
          this.showCartError(typeof error.description === 'string' ? error.description : '');
          return;
        }
        this.emit('addall', { count: known.length, failed: 0, value: this.total() });
        try { localStorage.removeItem(this.storageKey); } catch (e) { /* noop */ }
        history.replaceState(null, '', location.pathname + location.search);
        window.location.href = this.cfg.goToCheckout ? this.root + '/checkout' : this.cfg.cartUrl;
      } catch (e) {
        this.showCartError('');
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }

    showCartError(message) {
      const error = this.querySelector('[data-qo-cart-error]');
      error.hidden = false;
      error.querySelector('[data-qo-cart-error-text]').textContent =
        (message ? message + ' ' : '') + this.t.cartError;
      error.querySelector('a').focus();
    }

    /* ------------------------------------------------------------- details */

    async showInfo(sku) {
      const it = this.bySku[sku];
      if (!it) return;
      this.activeInfo = sku;

      this.querySelector('[data-qo-info-cat]').textContent = it.c;
      this.querySelector('[data-qo-info-name]').textContent = it.t;

      const media = this.querySelector('[data-qo-info-media]');
      media.innerHTML = this.cfg.showImages && it.img
        ? '<img src="' + this.esc(this.img(it.img, 640)) + '" alt="' + this.esc(it.t) + '" loading="lazy">'
        : '';

      const facts = [
        [this.t.itemNumber, '#' + it.sku],
        it.vt ? [this.t.packet, it.vt] : null,
        [this.t.price, this.money.format(it.p / 100)],
        it.o ? [this.t.certified, this.t.usdaOrganic] : null,
        it.hl ? [this.t.type, this.t.heirloom] : null,
        [this.t.availability, it.a ? this.t.inStock : this.t.soldOut]
      ].filter(Boolean);

      this.querySelector('[data-qo-info-facts]').innerHTML = facts.map((f) => (
        '<li><span>' + this.esc(f[0]) + '</span><b>' + this.esc(f[1]) + '</b></li>'
      )).join('');

      const inList = this.list.some((i) => i.sku === sku);
      this.querySelector('[data-qo-info-add]').textContent = inList ? this.t.addOneMore : this.t.addToList;

      this.querySelector('[data-qo-info-link]').innerHTML =
        '<a href="' + this.root + '/products/' + this.esc(it.h) + '" target="_blank" rel="noopener">' +
        this.esc(this.t.viewProduct) + '</a>';

      const desc = this.querySelector('[data-qo-info-desc]');
      desc.innerHTML = '';
      this.openSheet('info');

      /* Description is fetched on demand rather than cached, to keep the
         index small enough for localStorage. */
      if (this.descCache[it.h] == null) {
        try {
          const res = await fetch(this.root + '/products/' + it.h + '.js', { signal: this.abort.signal });
          const data = await res.json();
          this.descCache[it.h] = data.description || '';
        } catch (e) {
          this.descCache[it.h] = '';
        }
      }
      if (this.activeInfo === sku) desc.innerHTML = this.descCache[it.h];
    }

    /* --------------------------------------------------------------- sheets */

    openSheet(name) {
      this.lastFocus = document.activeElement;
      const row = this.lastFocus && this.lastFocus.closest('.qo__row');
      this.lastFocusSku = row && row.getAttribute('data-sku');
      this.querySelector('.qo__wrap').inert = true;
      const scrim = this.querySelector('[data-qo-scrim="' + name + '"]');
      scrim.setAttribute('data-open', '1');
      const focusable = scrim.querySelector('button, input, a[href]');
      if (focusable) focusable.focus();
      document.body.style.overflow = 'hidden';
    }

    closeSheets() {
      this.querySelectorAll('.qo__scrim').forEach((s) => s.setAttribute('data-open', '0'));
      document.body.style.overflow = '';
      this.querySelector('.qo__wrap').inert = false;
      const row = Array.from(this.el.rows.children).find((item) => item.getAttribute('data-sku') === this.lastFocusSku);
      const target = this.lastFocus && this.lastFocus.isConnected ? this.lastFocus : row && row.querySelector('[data-act="info"]');
      (target || this.el.input).focus({ preventScroll: true });
    }

    /* ---------------------------------------------------------------- browse */

    renderTabs() {
      if (!this.el.tabs) return;
      this.sections = [];
      this.index.forEach((it) => {
        if (it.sec && this.sections.indexOf(it.sec) < 0) this.sections.push(it.sec);
      });
      this.sections.sort();
      if (!this.activeSec || this.sections.indexOf(this.activeSec) < 0) {
        this.activeSec = this.sections[0];
      }
      this.el.tabs.innerHTML = this.sections.map((s) => (
        '<button type="button" class="qo__tab" data-sec="' + this.esc(s) + '"' +
        ' aria-pressed="' + (s === this.activeSec) + '">' + this.esc(s) + '</button>'
      )).join('');
      this.renderCats();
    }

    renderCats() {
      if (!this.el.catGrid) return;
      const map = Object.create(null);
      this.index.forEach((it) => {
        if (it.sec !== this.activeSec || !it.c) return;
        map[it.c] = (map[it.c] || 0) + 1;
      });
      this.el.catGrid.innerHTML = Object.keys(map).sort().map((k) => (
        '<button type="button" data-cat="' + this.esc(k) + '"><b>' + this.esc(k) + '</b>' +
        '<i>' + map[k] + '</i></button>'
      )).join('');
    }

    /* ------------------------------------------------------- toast and a11y */

    toast(msg, undo) {
      this.el.toastText.textContent = msg;
      this.el.toastAction.hidden = !undo;
      this.el.toastAction.textContent = this.t.undo;
      this.el.toastAction.onclick = () => { if (undo) undo(); this.hideToast(); };
      this.el.toast.setAttribute('data-show', '1');
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => this.hideToast(), undo ? 6000 : 2800);
    }

    hideToast() {
      if (document.activeElement === this.el.toastAction) this.el.input.focus({ preventScroll: true });
      this.el.toastAction.hidden = true;
      this.el.toast.setAttribute('data-show', '0');
    }

    say(m) { this.el.live.textContent = m; }

    /* Namespaced so it cannot collide with the theme's own data layer.
       Listen for catalog-quick-order:* on document. */
    emit(name, detail) {
      document.dispatchEvent(new CustomEvent('catalog-quick-order:' + name, {
        bubbles: true,
        detail: Object.assign({ sectionId: this.cfg.sectionId }, detail)
      }));
    }

    /* --------------------------------------------------------------- events */

    bind() {
      const input = this.el.input;
      window.addEventListener('hashchange', () => {
        if (!/^#l=.+$/.test(location.hash)) return;
        this.loadList();
        this.render();
        this.toast(this.t.restored);
      }, { signal: this.abort.signal });

      input.addEventListener('input', () => this.renderTA(), { signal: this.abort.signal });
      input.addEventListener('focus', () => { if (input.value.trim()) this.renderTA(); }, { signal: this.abort.signal });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { e.preventDefault(); this.moveTA(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); this.moveTA(-1); }
        else if (e.key === 'Enter') {
          e.preventDefault();
          if (this.taIdx > -1 && this.taItems[this.taIdx]) this.commit(this.taItems[this.taIdx].sku);
        }
      }, { signal: this.abort.signal });

      this.el.ta.addEventListener('click', (e) => {
        const row = e.target.closest('.qo__tarow');
        if (!row) return;
        this.commit(this.taItems[parseInt(row.getAttribute('data-i'), 10)].sku);
      }, { signal: this.abort.signal });

      this.el.addBtn.addEventListener('click', () => {
        if (this.taIdx > -1 && this.taItems[this.taIdx]) this.commit(this.taItems[this.taIdx].sku);
      }, { signal: this.abort.signal });

      this.el.rows.addEventListener('click', (e) => {
        const b = e.target.closest('[data-act]');
        if (!b) return;
        const sku = b.closest('.qo__row').getAttribute('data-sku');
        const act = b.getAttribute('data-act');
        const row = this.list.find((i) => i.sku === sku);
        if (act === 'inc' && row) this.setQty(sku, row.qty + 1);
        if (act === 'dec' && row) this.setQty(sku, row.qty - 1);
        if (act === 'del') this.remove(sku);
        if (act === 'info') this.showInfo(sku);
      }, { signal: this.abort.signal });

      this.el.rows.addEventListener('change', (e) => {
        const i = e.target.closest('[data-act="qty"]');
        if (!i) return;
        this.setQty(i.closest('.qo__row').getAttribute('data-sku'), parseInt(i.value, 10) || 0);
      }, { signal: this.abort.signal });

      this.el.clear.addEventListener('click', () => {
        const snapshot = this.list.slice();
        this.list = [];
        this.render();
        this.toast(this.t.cleared, () => { this.list = snapshot; this.render(); });
      }, { signal: this.abort.signal });

      const infoAdd = this.querySelector('[data-qo-info-add]');
      infoAdd.addEventListener('click', () => {
        if (this.activeInfo) { this.add(this.activeInfo); this.closeSheets(); }
      }, { signal: this.abort.signal });

      const bulkBtn = this.querySelector('[data-qo-bulk-add]');
      if (bulkBtn) bulkBtn.addEventListener('click', () => this.bulkAdd(), { signal: this.abort.signal });

      this.querySelector('[data-qo-save]').addEventListener('click', () => {
        this.el.link.value = this.savedListUrl();
        this.openSheet('save');
        const share = this.querySelector('[data-qo-share]');
        if (share && navigator.share) share.hidden = false;
      }, { signal: this.abort.signal });

      this.querySelector('[data-qo-copy]').addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        this.el.link.select();
        try { await navigator.clipboard.writeText(this.el.link.value); }
        catch (err) { try { document.execCommand('copy'); } catch (err2) { /* selection stands in */ } }
        btn.textContent = this.t.copied;
        setTimeout(() => { btn.textContent = this.t.copy; }, 1800);
      }, { signal: this.abort.signal });

      const mailto = this.querySelector('[data-qo-mailto]');
      if (mailto) mailto.addEventListener('click', () => {
        window.location.href = 'mailto:?subject=' + encodeURIComponent(this.t.mailSubject) +
          '&body=' + encodeURIComponent(this.mailBody());
      }, { signal: this.abort.signal });

      const share = this.querySelector('[data-qo-share]');
      if (share) share.addEventListener('click', async () => {
        try {
          await navigator.share({
            title: this.t.shareTitle,
            text: this.mailBody(),
            url: this.el.link.value
          });
        } catch (e) { /* the reader dismissed the sheet */ }
      }, { signal: this.abort.signal });

      this.el.cartBtn.addEventListener('click', () => this.addAllToCart(), { signal: this.abort.signal });

      if (this.el.tabs) {
        this.el.tabs.addEventListener('click', (e) => {
          const b = e.target.closest('[data-sec]');
          if (!b) return;
          this.activeSec = b.getAttribute('data-sec');
          this.renderTabs();
        }, { signal: this.abort.signal });
      }

      if (this.el.catGrid) {
        this.el.catGrid.addEventListener('click', (e) => {
          const b = e.target.closest('[data-cat]');
          if (!b) return;
          input.value = b.getAttribute('data-cat');
          this.renderTA();
          input.focus();
          input.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        }, { signal: this.abort.signal });
      }

      this.onDocClick = (e) => {
        if (this.contains(e.target) && !e.target.closest('.qo__finder, [data-qo-catgrid]')) this.closeTA();
        if (!this.contains(e.target)) this.closeTA();
        if (e.target.classList && e.target.classList.contains('qo__scrim')) this.closeSheets();
        if (e.target.closest && e.target.closest('[data-qo-close]')) this.closeSheets();
      };
      document.addEventListener('click', this.onDocClick, { signal: this.abort.signal });

      this.onKey = (e) => {
        if (e.key === 'Escape') {
          if (this.querySelector('.qo__scrim[data-open="1"]')) { this.closeSheets(); return; }
          if (this.el.ta.getAttribute('data-open') === '1') this.closeTA();
        }
        if (e.key === 'Tab') {
          const sheet = this.querySelector('.qo__scrim[data-open="1"] .qo__sheet');
          if (!sheet) return;
          const f = sheet.querySelectorAll('button:not([hidden]), input:not([type="hidden"]), a[href], textarea');
          if (!f.length) return;
          const first = f[0];
          const last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      };
      document.addEventListener('keydown', this.onKey, { signal: this.abort.signal });

      this.onPanelScroll = () => {
        const isDesktop = window.matchMedia('(min-width: 900px)').matches;
        this.el.right.classList.toggle('qo__right--stuck', isDesktop && this.el.right.getBoundingClientRect().top <= 24);
      };
      window.addEventListener('scroll', this.onPanelScroll, { passive: true, signal: this.abort.signal });
      this.onResize = () => { this.syncDock(); this.onPanelScroll(); };
      window.addEventListener('resize', this.onResize, { signal: this.abort.signal });
      this.onPanelScroll();
    }

    commit(sku) {
      this.add(sku);
      this.el.input.value = '';
      this.closeTA();
      this.el.addBtn.disabled = true;
      this.el.input.focus(); /* keeps the keying rhythm going */
    }

    bulkAdd() {
      const area = this.querySelector('[data-qo-bulk]');
      const report = this.querySelector('[data-qo-bulk-report]');
      const tokens = area.value.split(/[\s,;]+/).filter(Boolean);
      let added = 0;
      const bad = [];
      let pending = null;

      tokens.forEach((tok) => {
        const m = tok.match(/^#?(\d{3,})(?:[xX*](\d{1,2}))?$/);
        if (m) {
          if (this.bySku[m[1]]) { this.add(m[1], parseInt(m[2] || '1', 10), true); added += 1; }
          else bad.push(m[1]);
          pending = m[1];
          return;
        }
        const q = tok.match(/^[xX*](\d{1,2})$/);
        if (q && pending && this.bySku[pending]) { this.setQty(pending, parseInt(q[1], 10)); return; }
        bad.push(tok);
      });

      this.render();
      let msg = added ? this.fmt(this.t.bulkAdded, { count: added }) : this.t.bulkNone;
      if (bad.length) {
        msg += ' ' + this.fmt(this.t.bulkNotFound, {
          list: bad.slice(0, 6).join(', ') + (bad.length > 6 ? '…' : '')
        });
      }
      report.textContent = msg;
      if (added) { area.value = ''; this.say(msg); }
    }

    mailBody() {
      const lines = this.list.filter((i) => this.bySku[i.sku]).map((i) => {
        const it = this.bySku[i.sku];
        return '#' + it.sku + '  ' + it.t + (it.vt ? ' (' + it.vt + ')' : '') + '  x' + i.qty;
      });
      const link = this.savedListUrl();
      return this.t.mailIntro + '\n\n' + lines.join('\n') + '\n\n' + link + '\n';
    }
  }

  if (!customElements.get('catalog-quick-order')) {
    customElements.define('catalog-quick-order', CatalogQuickOrder);
  }

  } catch(e) { console.error(e); }
})();
})();
